import apiUrl from '../../../constants'
import axios from 'axios'
import Handover from './Handover/index.vue';

export default {
  name: 'AutoHandover',
  components: {
    'first': Handover,
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Handover'
        },
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoHandover/AutoHandover.js